var parent = require('../../actual/object/keys');

module.exports = parent;